module.exports = __webpack_public_path__ + "img/6.53de8743.jpg";